export const css = {
	root: 'JP88AI2t',
	' _key': 'certwise-theme/dojo/grid-body'
};

export default css;
